/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index grid to autogenerate all the components and extensions
 * Used by "prepareGrids"
 */

import Grid from './grid/Grid'
export * from './grid/Grid'
export default Grid
